module.exports = __webpack_public_path__ + "img/home_16_1.80cd84fb.svg";